import { useQueryClient } from '@tanstack/react-query';
import keys from './keys';
import customerKeys from '../customer/keys';
import userKeys from '../user/keys';
import useApiMutation from '../useApiMutation';

const useImportShow = () => {
  const queryClient = useQueryClient();

  const mutation = useApiMutation({
    getRequestUrl: () => '/shows/import',
    method: 'POST',
    onSuccess: ({ show }) => {
      if (show) {
        queryClient.setQueryData(keys(show._id).show, show);
        queryClient.invalidateQueries(keys().shows);
        queryClient.invalidateQueries(customerKeys.customer);
        queryClient.invalidateQueries(userKeys.me);
      }
    },
  });

  return {
    importShow: mutation.mutate,
    isImportShowLoading: mutation.isLoading,
    isImportShowError: mutation.isError,
    isImportShowSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useImportShow;
